import React from 'react';
import { Mail, Phone, Facebook, Instagram, Linkedin, Twitter, Youtube } from 'lucide-react';
import { contact } from '../mock';

const TopBar = () => {
  return (
    <div className="hidden md:block bg-[#0b1a1a] text-white text-xs">
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <a href={`mailto:${contact.email}`} className="flex items-center gap-2 hover:text-emerald-400 transition-colors">
            <Mail className="w-3.5 h-3.5" />
            <span>{contact.email}</span>
          </a>
          <a href={`tel:${contact.phone1}`} className="flex items-center gap-2 hover:text-emerald-400 transition-colors">
            <Phone className="w-3.5 h-3.5" />
            <span>{contact.phone1}</span>
          </a>
          {contact.phone2 && (
            <a href={`tel:${contact.phone2}`} className="flex items-center gap-2 hover:text-emerald-400 transition-colors">
              <Phone className="w-3.5 h-3.5" />
              <span>{contact.phone2}</span>
            </a>
          )}
        </div>
        <div className="flex items-center gap-2">
          {[Facebook, Instagram, Linkedin, Twitter, Youtube].map((Icon, i) => (
            <a key={i} href="#" className="w-7 h-7 rounded-full bg-white/10 hover:bg-emerald-500 grid place-items-center transition-colors">
              <Icon className="w-3.5 h-3.5" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
